import { createTypes } from 'reduxsauce';

export default createTypes(
    `
    SET_WATCH_LIST
    WATCH_LIST_REQUEST
    WATCH_LIST_RESPONSE
`,
    {
        prefix: 'watchList/'
    }
);
